import { Icon, IconProps } from ".";

export const ExternalLink = (props: IconProps) => {
  return (
    <Icon {...props}>
      <>
        <path d="M19.1602 7.5H28.5V16.8398H26.1563V12.1757H23.8359V14.5078H21.5039V16.8398H19.1719V19.1719H16.8281V16.8281H19.1602V14.4961H21.4922V12.1641H23.8243V9.84371H19.1602V7.5Z" />
        <path d="M26.1563 26.1563V21.4922H28.5V26.168H26.168V28.5H9.83204V26.168H7.5V9.83204H9.83204V7.5H14.5078V9.84371H9.84371V26.1563H26.1563Z" />
      </>
    </Icon>
  );
};
